module.exports = kolibriCoreAppGlobal.lib.vue;